/**
 * PostHog Event Registry
 * Single source of truth for all event names.
 * Use these constants everywhere — never hardcode event strings.
 */

export const EVENTS = {
  // Auth
  SIGN_UP: 'sign_up',
  SIGN_IN: 'sign_in',
  SIGN_OUT: 'sign_out',

  // Session
  SESSION_STARTED: 'session_started',
  SESSION_ENDED: 'session_ended',

  // Onboarding
  ONBOARDING_STEP: 'onboarding_step',
  TUTORIAL_STEP: 'tutorial_step',
  FIRST_ACTION: 'first_action_after_onboarding',
  POST_ONBOARDING_JOURNEY: 'post_onboarding_journey',

  // Character
  CHARACTER_CREATION_STARTED: 'character_creation_started',
  CHARACTER_CREATED: 'character_created',
  CHARACTER_ANIMATED: 'character_animated',
  CHARACTER_ENHANCED: 'character_enhanced',
  CHARACTER_EDITED: 'character_edited',

  // Story (video)
  STORY_CREATION_STARTED: 'story_creation_started',
  STORY_CREATED: 'story_created',

  // Storybook (audiobook)
  STORYBOOK_CREATION_STARTED: 'storybook_creation_started',
  STORYBOOK_CREATED: 'storybook_created',
  STORYBOOK_PLAYED: 'storybook_played',
  STORYBOOK_PAGE_TURNED: 'storybook_page_turned',
  STORYBOOK_COMPLETED: 'storybook_completed',

  // Web2app funnel (/funnel-auth) — every step lives at one URL, so each of
  // these is emitted explicitly; see hooks/useFunnelAnalytics.js
  FUNNEL_STARTED: 'funnel_started',
  FUNNEL_STEP_VIEWED: 'funnel_step_viewed',
  FUNNEL_STEP_COMPLETED: 'funnel_step_completed',
  FUNNEL_BACK_CLICKED: 'funnel_back_clicked',
  FUNNEL_PHOTO_ADDED: 'funnel_photo_added',
  FUNNEL_PRESET_FRIEND_SELECTED: 'funnel_preset_friend_selected',
  FUNNEL_GENERATION_STARTED: 'funnel_generation_started',
  FUNNEL_GENERATION_COMPLETED: 'funnel_generation_completed',
  FUNNEL_GENERATION_FAILED: 'funnel_generation_failed',
  FUNNEL_SIGNIN_STARTED: 'funnel_signin_started',
  FUNNEL_SIGNIN_FAILED: 'funnel_signin_failed',
  FUNNEL_EXISTING_ACCOUNT: 'funnel_existing_account',
  FUNNEL_COMPLETED: 'funnel_completed',
  FUNNEL_COMPLETION_FAILED: 'funnel_completion_failed',
  FUNNEL_INVALID_LINK: 'funnel_invalid_link',
  // Tapped the "watch while you wait" episode on the generating step
  FUNNEL_WAIT_VIDEO_PLAYED: 'funnel_wait_video_played',

  // Book-promo funnel variant (/funnel-auth?variant=book)
  FUNNEL_BOOK_SELECTED: 'funnel_book_selected',
  FUNNEL_BOOK_ADDRESS_INVALID: 'funnel_book_address_invalid',
  FUNNEL_BOOK_ADDRESS_SKIPPED: 'funnel_book_address_skipped',
  FUNNEL_BOOK_ADDRESS_FAILED: 'funnel_book_address_failed',
  FUNNEL_BOOK_ADDRESS_HANDOFF_FAILED: 'funnel_book_address_handoff_failed',
  FUNNEL_FREE_BOOK_CLAIMED: 'funnel_free_book_claimed',
  FUNNEL_FREE_BOOK_FAILED: 'funnel_free_book_failed',

  // Content
  CONTENT_VIEWED: 'content_viewed',
  CONTENT_SHARED: 'content_shared',
  PAGE_VIEWED: 'page_viewed',

  // Purchases
  SUBSCRIPTION_PURCHASED: 'subscription_purchased',
  STARS_PURCHASED: 'stars_purchased',

  // Errors
  ERROR: 'error',
};
